import constants from 'constants/index'

const chipStatusColor = (status) => {
  return (status && constants.audits.CHIP_STATUS_COLOR[status]) || undefined
}

export default chipStatusColor
